import React from 'react';
import { Container } from 'react-bootstrap';
import Heading from '../../../components/Ui/Heading';

const DeliveryInformation = () => {
	return (
		<Container>
			<Heading>Delivery Information</Heading>
			<p>
				We believe in <b>'Fastest Delivery Service'</b> for our customers. So,
				unless <u>any uncertain circumstances</u>; we deliver our products to
				deliver within 24 hours anywhere inside Dhaka city.{' '}
			</p>
		</Container>
	);
};

export default DeliveryInformation;
